import { css } from '@emotion/react'
import React from 'react'

export const AccountTabSection: React.FC<React.HTMLProps<HTMLDivElement>> = ({
  children,
  ...props
}) => {
  return (
    <section
      css={css`
        padding: 0 16px 16px;
        max-width: 1200px;
        margin-left: auto;
        margin-right: auto;
        > div {
          &.save-button {
            margin-top: 56px;
          }
        }
      `}
      {...props}
    >
      {children}
    </section>
  )
}
